import { memo } from "react";
import { VehicleContractStatsCardProps } from "./types";
import { NoResults } from "ui/components/NoResults";

const VehicleContractStatsCard: React.FC<VehicleContractStatsCardProps> = ({
  fleetVehicleDetail,
}) => {
  if (!fleetVehicleDetail.id) return null;

  return (
    <div className="p-4">
      <NoResults message="Statistika ugovora - u izradi" />
    </div>
  );
};

export default memo(VehicleContractStatsCard);